<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('base.dc.dcNo')" prop="dcNo">
                <el-input v-model.trim="queryCondition.dcNo" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.dc.dcName')" prop="dcName">
                <el-input v-model.trim="queryCondition.dcName" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="!isShowRadio">
              <el-form-item :label="$t('base.dc.dcStatus')" prop="status">
                <el-select v-model="queryCondition.status" clearable style="width:100%">
                  <el-option :label="$t('common.all')" value=""></el-option>
                  <el-option :key="index" v-for="(item,index) in statusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button size="mini" @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row" v-if="!isShowRadio">
        <el-button size="mini" class="btn" type="primary" v-acl="DcNew" @click="showDcDialog('add')">{{$t('common.addNew')}}</el-button>
        <el-button size="mini" class="btn" type="danger" v-acl="DcDelete" @click="deleteDc">{{$t('common.del')}}</el-button>
      </el-row>
      <el-row v-if="isShowRadio" type="flex" justify="start" style="margin-bottom:10px">
        <el-button size="mini" @click="onSelect" type="primary">选择</el-button>
      </el-row>
      <el-table sortable max-height="435" :data="dcList" ref="dcDataTable" border highlight-current-row class="table">
        <el-table-column align="center" width="56" :label="$t('common.select')">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" :label="scope.row" v-if="isShowRadio">{{scope.row.tmDcId}}</el-radio>
            <el-radio v-model="radioVal" :label="scope.row.tmDcId" v-else>&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column sortable prop="dcNo" :label="$t('base.dc.dcNo')">
          <template slot-scope="scope">
            <el-link type="primary" @click="showDcDialog('update',scope.row)"> {{scope.row.dcNo}}</el-link>
          </template>
        </el-table-column>
        <el-table-column sortable prop="dcName" :label="$t('base.dc.dcName')"></el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <!--=========数据列表END================-->
    <!--=========DC主数据添加/修改=========-->
    <el-dialog :title="$t('base.dc.dcInfo')" :visible.sync="dcDialog" width="600px">
      <el-form :model="dcInfo" ref="dcInfoForm" class="form_border" :rules="dcRules" :label-position="labelPosition" label-width="120px">
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('base.dc.dcNo')" placeholder="" prop="dcNo">
              <el-input v-model="dcInfo.dcNo" class="handle-input" />
            </el-form-item>

            <el-form-item :label="$t('base.dc.dcName')" placeholder="" prop="dcName">
              <el-input v-model="dcInfo.dcName" class="handle-input" />
            </el-form-item>

            <el-form-item :label="$t('base.dc.dcStatus')" placeholder="" prop="status">
              <el-select v-model="dcInfo.status" class="handle-input">
                <el-option :label="$t('common.sel')" value=""></el-option>
                <el-option :key="index" v-for="(item,index) in statusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button size="mini" class="btn" type="primary" @click="dcDialog = false">{{$t('common.close')}}</el-button>
        <el-button size="mini" class="btn" type="primary" @click="saveOrUpdateDc">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
    <!--=========DC主数据添加/修改EN=========-->
  </div>
</template>
<script>
import { dcService } from "../../../api/base-data/dc";
import { inputChoiceService } from "../../../api/common/input-choice";
import commonFunction from "../../../utils/dataTableUtils"
import { Message } from "element-ui";
export default {
  name: 'dc',
  props: ['isType', 'isTrigger'],
  data() {
    return {
      isShowRadio: false,//如果是SQMS点击Facility编码时则显示
      totalCount: 0,
      dcList: [],
      labelPosition: 'right',
      queryCondition: { pageSize: 15, pageNum: 1, dcNo: "", dcName: "", status: "", types: ['DC'] },
      dcDialog: false,
      dcInfo: {},
      method: "",
      dcRules: {
        dcNo: [
          { required: true, message: this.$t('base.dc.inputDcNo'), trigger: 'blur' }
        ],
        dcName: [
          { required: true, message: this.$t('base.dc.inputDcName'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('base.dc.inputStatus'), trigger: 'blur' }
        ]
      },
      statusList: [],
      radioVal: null,
    }
  },
  created() {
    this.queryData(1);
    this.getInputChoiceValues();
  },
  watch: {
    isType: {
      handler(newV) {
        console.log("GY🚀 ~ handler ~ newV:", newV);
        if (newV == 'DQMP') {
          this.isShowRadio = true
          this.queryCondition.status = '1'
        }
      },
      immediate: true
    },
    isTrigger: {
      handler(newV) {
        console.log("GY🚀 ~ isTrigger ~ newV:", newV);
        if (newV) {
          this.queryData(1);
        }
      },
      immediate: true
    }
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      dcService.getDcData(this.queryCondition).then((res) => {
        this.dcList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    onSelect() {
      console.log('radioVal', this.radioVal)
      if (this.radioVal) {
        this.$emit('setDC', this.radioVal)
      } else {
        this.$message.warning('请选择一条数据')
      }
    },
    // onCancel() {
    //   this.isShowRadio = false
    //   this.$emit('dialogBeforeClose')
    // },
    showDcDialog: function (method, row) {
      this.clearVlidate("dcInfoForm");
      this.method = method;
      if ('add' === method) {
        this.dcInfo = {};
      } else {
        if (this.actionCheck.actionCheck('DcEdit') === false) {
          this.$message.error(this.$t('common.noPermission'))
          return false
        }
        this.dcInfo = row;
      }
      this.dcDialog = true;
    },
    saveOrUpdateDc: function () {
      let validFlag = false;
      this.$refs['dcInfoForm'].validate((valid) => {
        validFlag = valid;
      });
      if (!validFlag) {
        return;
      }
      dcService.saveOrUpdateDc(this.dcInfo, this.method).then((res) => {
        if (res.meta.success) {
          Message({ message: this.$t('common.saveSuccess'), type: "success" });
          this.dcDialog = false;
          this.queryData();
        } else {
          Message({ message: res.meta.msg, type: "error" });
          this.queryData();
        }
      });
    },
    deleteDc: function () {
      if (!!this.radioVal) {
        //请确认是否删除!
        this.$confirm(this.$t('common.delConfirm'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          cancelButtonClass: 'el-button--primary',
          confirmButtonClass: 'el-button--primary',
          type: 'warning'
        }).then(() => {
          dcService.deleteDc(this.radioVal).then((res) => {
            if (res.meta.success) {
              Message({ message: this.$t('common.delSuccess'), type: "success" });
              this.queryData();
            } else {
              Message({ message: res.meta.msg, type: "error" });
              this.queryData();
            }
          });
        }).catch(() => {

        });
      } else {
        Message({ message: '请选择需要删除的DC', type: "error" });
      }
    },
    //清除校验信息
    clearVlidate: function (refFormName) {
      if (this.$refs[refFormName]) {
        this.$refs[refFormName].clearValidate();
      }
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["COMMON:STATUS_DISABLE_ENABLE"] = "COMMON:STATUS_DISABLE_ENABLE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.statusList = res["COMMON:STATUS_DISABLE_ENABLE"];
      });
    }

  },
  extends: commonFunction
}
</script>
<style scoped >
.handle-input {
  width: 95%;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}
</style>
